import classNames from 'classnames'

import { Progress } from 'client/semantic-imports'
import { getLocalLastUserConfig } from 'client/services'
import { DEFAULT_THEME } from 'client/utils'

import AppParagraph from '../AppParagraph/app-paragraph'

import './app-progress-bar.scss'

type Props = {
  total: number
  value: number
  label?: string
  loading?: boolean
  progress?: 'percent' | 'ratio'
  indicating?: boolean
}

const AppProgressBar = ({
  total = 0,
  value = 0,
  label = '',
  loading = false,
  progress = 'ratio',
  indicating,
}: Props) => {
  const currentTheme = getLocalLastUserConfig().theme || DEFAULT_THEME

  return (
    <div
      className={classNames(
        'appProgressBar',
        value === 0 && 'noBackground',
        currentTheme
      )}
    >
      {label ? <AppParagraph size="small" text={label} marginBottom="xxsmall" /> : null}
      <Progress
        total={total}
        value={value}
        progress={loading ? false : progress}
        indicating={indicating !== undefined ? indicating : total !== value}
        success={total > 0 && total === value}
        size="large"
        precision={progress === 'percent' ? 1 : undefined}
      />
    </div>
  )
}

export default AppProgressBar
